import React from 'react';
import {
  Button,
} from 'src/components/Component';
import { Link } from 'react-router-dom';
import DataTable from 'src/components/data-table';
import API_ROUTES from "src/config/api";
import CurrencyFormat from 'src/transformer/currency-format';
import moment from "moment";
import { convertPenniesToDecimals } from "src/utils/money";
import { ArrowPathIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import ScheduledPaymentStatusTransformer from 'src/transformer/scheduled-payment-status';

const RowFormatter = ({ item, triggerReload, enums, childFilterState }) => {
  return (
    <React.Fragment>
      <tr key={item.id} className="tb-tnx-item">
        <td className="border-r">
          <Link to={`/booking/${item?.booking?.id}`} className="text-violet-800 underline">{item?.booking?.booking_reference}</Link>
        </td>
        <td className="border-r text-center">
          <Link to={`/customer/${item?.customer?.id}`} className="text-violet-800 underline">{item?.customer?.customer_name}</Link>
        </td>
        <td className="border-r text-center">
          {item?.transaction?.id && (
            <Link to={`/transaction/${item?.transaction?.id}`} className="text-violet-800 underline">{item?.transaction?.id}</Link>
          )}
          { !item?.transaction?.id && (
            <span className="text-violet-800">-</span>
          )}
        </td>
        {childFilterState === true && (
          <td className="text-center border-l">
            <span className="title">{item.organisation.name}</span>
          </td>
        )}
        <td className="border-l text-center">
          {CurrencyFormat(enums.currency, item.currency).format(convertPenniesToDecimals(item.amount))}
        </td>
        <td className="border-l text-center">
          {moment(item.created_at).format('Do MMM, HH:mm')}
        </td>
        <td className="text-center">
          {moment(item.execute_after).format('Do MMM, HH:mm')}
        </td>
        <td className="border-l text-center">
          <ScheduledPaymentStatusTransformer status={item.status} />
        </td>
        <td className="border-l text-center">
          <Link to={`/booking/${item?.booking?.id}/scheduled-transactions`} className="text-violet-800">
            <InformationCircleIcon className="h-5 w-5 inline" />
          </Link>
        </td>
      </tr>
    </React.Fragment>
  );
}

const TableHeaders = ({ childFilterState }) => (
  <React.Fragment>
    <tr className="tb-tnx-head">
      <th rowSpan={2} className="border-r text-left">Booking</th>
      <th rowSpan={2} className="border-r text-center">Customer</th>
      <th rowSpan={2} className="border-r text-center">Transaction</th>
      {childFilterState === true && (
        <th rowSpan={2} className="text-center border-r">
          <span>Organisation</span>
        </th>
      )}
      <th rowSpan={2} className="border-r text-center">Amount</th>
      <th className="text-center" colSpan={2}>Key Dates</th>
      <th rowSpan={2} className="border-l text-center">Status</th>
      <th rowSpan={2} className="border-l text-center">Actions</th>  
    </tr>
    <tr className="tb-tnx-head">
      <th className="text-center">Created Date</th>
      <th className="text-center">Execute Date</th>
    </tr>
  </React.Fragment>
);

const PageOptions = ({ triggerReload, loading }) => {
  return (
    <ul className="nk-block-tools g-3">
      <li>
        <Button disabled={loading} className="border-violet-800 bg-white text-violet-800 text-xs hover:bg-slate-800 hover:border-slate-800" id="trigger_reload" onClick={() => triggerReload()}>
          <ArrowPathIcon className='h-4 w-5' />
        </Button>
      </li>
    </ul>
  );
};

const Declines = () => {
  return (
    <DataTable
      title="Scheduled Payments"
      columnCount={9}
      itemTitle="Scheduled Payments"
      TableHeaders={TableHeaders}
      RowFormatter={RowFormatter}
      PageOptions={PageOptions}
      endpoint={API_ROUTES.payment['scheduled-payments:get']()}
      childOrganisationsOption={true}
      largeHeading={true}
      noHeader={true}
      emptyState={true}
      totalFilterOption={true}
    />
  );
};

export default Declines;
